import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useOrderRetractionReasons(userId) {
  const { data, _error, mutate } = useSWR(
    userId ? `/orderretractionreasons/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    orderRetractionReasons: data,
    mutate: mutate,
  };
}

export default useOrderRetractionReasons;
